import { PlaidLink, isPlaidAvailable } from '@helios/frontend-capacitor-plaid-link';
import { useEffect } from 'react';
import { registerUrlInterceptor } from '../../capacitor-plugins/appUrl-interceptors';

const usePlaidUrlInterceptor = (): void => {
  useEffect(() => {
    if (!isPlaidAvailable()) return;
    return registerUrlInterceptor(async (url) => {
      if (!new URL(url).searchParams.has('oauth_state_id')) return false;
      try {
        await PlaidLink.continueFromRedirect({ url });
      } catch (err) {
        console.error('[PlaidLink] continueFromRedirect failed:', err);
      }
      return true;
    });
  }, []);
};

export default usePlaidUrlInterceptor;
